/**
 * The city list every embed customizer offers.
 *
 * One owner: the panchang and choghadiya customizers each carried an identical
 * twelve-entry copy of this array. Divergent copies of a picker mean a city
 * added for one widget silently misses the others, and — as the 2026-08-21
 * attribution-link defect showed — a block duplicated across widgets is a block
 * that acquires the same bug in every copy.
 *
 * Slugs must exist in `CITY_MAP` (data/domain/geo/cities.yaml), which is what
 * resolves them to coordinates and an IANA timezone at render time.
 */
export interface PopularCity {
  readonly slug: string;
  readonly name: string;
  readonly nameHi: string;
}

export const POPULAR_CITIES: readonly PopularCity[] = [
  { slug: "new-delhi", name: "New Delhi", nameHi: "नई दिल्ली" },
  { slug: "mumbai", name: "Mumbai", nameHi: "मुंबई" },
  { slug: "bangalore", name: "Bengaluru", nameHi: "बेंगलुरु" },
  { slug: "kolkata", name: "Kolkata", nameHi: "कोलकाता" },
  { slug: "chennai", name: "Chennai", nameHi: "चेन्नई" },
  { slug: "jaipur", name: "Jaipur", nameHi: "जयपुर" },
  { slug: "hyderabad", name: "Hyderabad", nameHi: "हैदराबाद" },
  { slug: "ahmedabad", name: "Ahmedabad", nameHi: "अहमदाबाद" },
  { slug: "pune", name: "Pune", nameHi: "पुणे" },
  { slug: "varanasi", name: "Varanasi", nameHi: "वाराणसी" },
  { slug: "lucknow", name: "Lucknow", nameHi: "लखनऊ" },
  { slug: "indore", name: "Indore", nameHi: "इंदौर" },
] as const;
